import { useCallback, useMemo, useState } from "react";
import { useAntecipationData } from "./use-antecipacao-queries";

export function useAntecipation() {
  const today = useMemo(() => new Date().toISOString().slice(0, 10), []);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  const filterDate = useMemo(() => {
    return selectedDate.toISOString().slice(0, 10);
  }, [selectedDate]);

  const {
    data: antecipationData,
    isLoading,
    isFetching,
    error,
  } = useAntecipationData(
    { filterDate },
    Boolean(filterDate)
  );

  const handleDateChange = useCallback((date: Date | undefined) => {
    if (date) {
      setSelectedDate(date);
    }
  }, []);

  const hasData = useMemo(() => {
    return (
      antecipationData &&
      antecipationData.antecipacoes &&
      antecipationData.antecipacoes.length > 0
    );
  }, [antecipationData]);

  const stats = useMemo(() => {
    if (!antecipationData) return null;
    return {
      valorTotal: antecipationData.valorTotal || 0,
      totalRegistros: antecipationData.totalRegistros || 0,
      status: antecipationData.status || "N/A",
    };
  }, [antecipationData]);

  const records = useMemo(() => {
    if (!antecipationData?.antecipacoes) return [];
    return antecipationData.antecipacoes.map((item, index) => ({
      ...item,
      id: item.id || `antecipation_${index}`,
    }));
  }, [antecipationData]);

  return {
    selectedDate,
    filterDate,
    antecipationData,
    stats,
    records,
    hasData,
    isLoading,
    isFetching,
    error,
    handleDateChange,
  };
}
